// extracted by mini-css-extract-plugin
module.exports = {"tender":"tender--2cMMG","btns":"btns--37lTS","boxTitle":"boxTitle--DzQIP","info":"info--2JHfQ","high":"high--2WhaW","code":"code--1vxrK","icons":"icons--1pp5e"};